module.exports = __webpack_public_path__ + "9310dca498008117c36053d031a99d1a.svg";